// # JavaScript to open external links in a new tab
document.addEventListener('DOMContentLoaded', function() {
	const links = document.querySelectorAll('a');
	links.forEach(function(link) {
		if (link.host !== window.location.host) {
			link.setAttribute('target', '_blank');
		}
	});
});